import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import {
  CmsBannerComponentMedia,
  CmsLinkComponent,
  CmsResponsiveBannerComponentMedia,
  WindowRef
} from '@spartacus/core';
import { CmsComponentData, LinkComponent } from '@spartacus/storefront';
import { CustomStorefrontService } from "../../../cms-structure/layout/custom-storefront/custom-storefront.service";

declare module '@spartacus/core' {
  interface CMSLinkComponent {
    icon?: CmsBannerComponentMedia | CmsResponsiveBannerComponentMedia;
  }
}

@Component({
  selector: 'app-custom-generic-link',
  templateUrl: './custom-cms-link.component.html',
  styleUrls: ['./custom-cms-link.component.scss'],
  standalone: false
})

export class CustomCMSLinkComponent extends LinkComponent {

  // @ViewChild('newsletterInput') newsletterInputElement: ElementRef;
  @ViewChild('newsletterInput', { read: ViewContainerRef }) newsletterInputElement;
  currentSiteClass: string;

  constructor(
    protected component: CmsComponentData<CmsLinkComponent>,
    protected customStorefrontService: CustomStorefrontService,
    protected winRef: WindowRef
  ) {
    super(component);
  }

  changeTab(classes: string): void {
    if (classes?.includes('outlet')) {
      this.winRef.localStorage.setItem('currentSite', 'outlet');
    } else if (classes?.includes('ohgar')) {
      this.winRef.localStorage.setItem('currentSite', 'ohgar');
    } else if (classes?.includes('ohbar')) {
      this.winRef.localStorage.setItem('currentSite', 'ohbar');
    }
  }

  goToElement(id: string): void {
    if (id?.includes('NewsLetterLink')) {
      const targetEl = this.winRef.document.getElementById('newsletter-section');
      const inputNewsletter = this.winRef.document.getElementById('input-newsletter');
      targetEl.scrollIntoView({ behavior: 'smooth' });
      inputNewsletter.click();
    } else if (id?.includes('ProfesionalLoggedLink')) {
      this.winRef.localStorage.setItem('professionalElement', 'chefsarea-professional');
      const targetEl = this.winRef.document.getElementById('chefsarea-professional');
      const yOffset = -100;

      if (targetEl) {
        const y = targetEl.getBoundingClientRect().top + this.winRef.nativeWindow.pageYOffset + yOffset;
        // targetEl.scrollIntoView({behavior: 'smooth', block: 'start'});
        this.winRef.nativeWindow.scrollTo({ top: y, behavior: 'smooth' });
        // window.scrollTo({top: y});
      }
    }
    const link = document.getElementById(id);
    if (link.closest('.HeaderLinks') !== undefined) {
      document.getElementById('close-button')?.click();
    }
  }
}

